import {
    requestGet as wsRequestGet,
    requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getMarketingConsent(userId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestGet(
            `/admin/MarketingConsent/${userId}`,
            language,
            timeZone,
            {},
            cancelToken
        );
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to get marketing consent: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function resetMarketingConsent(userId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestPost(`/admin/MarketingConsent/${userId}/reset`, language, timeZone, {}, null, cancelToken);
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to reset marketing consent: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function getMarketingConsentStats(language, timeZone, cancelToken) {
    try {
        const data = await wsRequestGet(`/admin/MarketingConsent/stats`, language, timeZone, {}, cancelToken);
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to get marketing consent stats: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function listMarketingConsents(consented, page, pageSize, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestGet(
            `/admin/MarketingConsent/list`,
            language,
            timeZone,
            { consented, page, pageSize },
            cancelToken
        );
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to list marketing consents: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}
